export var IndicatorLightType;
(function (IndicatorLightType) {
    IndicatorLightType[IndicatorLightType["Bit"] = 0] = "Bit";
    IndicatorLightType[IndicatorLightType["Word"] = 1] = "Word";
})(IndicatorLightType || (IndicatorLightType = {}));
